import React, { useEffect } from "react";
import { inject, observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import Box from "react-raster";
import { Heading, Paper, Text } from "src/components";
import { theme } from "src/config";
import { AuthStore, RoutingStore } from "src/stores";
import { Colors } from "src/types";
import Circle from "src/components/spinner";

interface IVerifyParams {
  token: string;
}

export interface IVerifyAccountProps {
  authStore?: AuthStore;
  routingStore?: RoutingStore;
  params: IVerifyParams; // This is injected so it has to be called match
}

export const VerifyAccount = inject(
  "authStore",
  "routingStore"
)(
  observer((props: IVerifyAccountProps): JSX.Element => {
    const { t, i18n } = useTranslation();
    const [token, setToken] = React.useState<string>("");
    const { verifyAccount } = props.authStore;
    const [result, setResult] = React.useState<any>();
    const [loading, setLoading] = React.useState<boolean>(true);

    useEffect(() => {
      const { params } = props;
      setToken(params?.token);
    }, []);

    useEffect(() => {
      const testToken = async () => {
        setLoading(true);
        setResult(await verifyAccount(token));
        setLoading(false);
      };
      testToken();
    }, [token]);

    return (
      <Paper $noShadow style={theme.paper.small}>
        <Box gridRowGap={theme.layout.gutter} alignItems="center">
          <Heading type="h3">{t("Verify_email")}</Heading>
          <Box>
            <hr />
          </Box>
          <Box justifyContent="center">
            {result == "success" && <Text>Alright, thank you!</Text>}
            {result != "success" && result && <Text>Verification failed</Text>}
            {loading && (
              <>
                <Text>Verifying your email!</Text>
                <Circle color={Colors.Primary} size={2} sizeUnit="rem" />
              </>
            )}
          </Box>
        </Box>
      </Paper>
    );
  })
);
